module.exports = __webpack_public_path__ + "img/logo-ayenda.a379ea0e.png";